(function($) {
    $(() => {
        $('#ask_phone').on('change', function () {
            $('#phone_wrapper').toggleClass('d-none');
        });


        function resetFrontForm() {
            $('.js-contact-form').trigger('reset');
            // grecaptcha.reset();
        }

        // front-form
        $('.js-contact-form').on('submit', function (e) {
            e.preventDefault();
            const $this = $(this);

            $(this)
                .find('.contact-btn')
                .prop('disabled', true);

            const formdata = $this.serializeArray();

            $.ajax({
                url: ajax.ajaxurl,
                type: 'POST',
                data: {
                    action: 'contact_form',
                    datas: formdata
                },
                success(data) {
                    const result = JSON.parse(data);
                    Swal.fire({
                        // title: result.title,
                        text: result.title,
                        imageUrl: '/wp-content/themes/wp-dmlab/assets/img/eredmeny.svg',
                        imageHeight: 100,
                        imageAlt: 'Pipa',
                        button: 'ok'
                    });
                    if (result.status == 'success') {
                        resetFrontForm();
                    }
                }
            }).done(response => {
                $this.find('.contact-btn').prop('disabled', false);
            });

        });
    });
})(jQuery);